import { render } from "./ImarVisitCard.vue?vue&type=template&id=b9075800"
import script from "./ImarVisitCard.vue?vue&type=script&lang=js"
export * from "./ImarVisitCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__